/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

// import DailyDemand from "./daily-demand";
import DailyDemand from "./daily-demand";
import MonthlyDemand from "./monthly-demand";

// Store
import { getSubModulesByRoleId } from "../../store";

// Cookies
import Cookies from "universal-cookie";
const cookies = new Cookies();

const NewDemand = ({ getSubModulesByRoleId, getSubModulesByRoleIdReducer }) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let dailyDemandModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "2898761c-f041-41d4-8e59-5c289c28c0ad",
  );

  let monthlyDemandModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "52a93c0b-3763-447f-a3e4-870c452ecce7",
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {dailyDemandModule && monthlyDemandModule ? (
              <>
                <TabView>
                  <TabPanel header="Daily Demand">
                    <DailyDemand />
                  </TabPanel>
                  <TabPanel header="Monthly Demand">
                    <MonthlyDemand />
                  </TabPanel>
                </TabView>
              </>
            ) : dailyDemandModule && !monthlyDemandModule ? (
              <TabView>
                <TabPanel header="Daily Demand">
                  <DailyDemand />
                </TabPanel>
              </TabView>
            ) : !dailyDemandModule && monthlyDemandModule ? (
              <TabView>
                <TabPanel header="Monthly Demand">
                  <MonthlyDemand />
                </TabPanel>
              </TabView>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(NewDemand);
